import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type InsuranceContractFormType = {
  readonly partnerId: string;
  readonly productName?: string;
  readonly insuranceAmount: number;
  readonly frequency: string;
  readonly note?: string;
};

export const getInsuranceContractFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<InsuranceContractFormType> = (t) => {
  return object({
    partnerId: string().required(t(Resources.Validation.Required)),
    productName: string().required(t(Resources.Validation.Required)),
    frequency: string().required(t(Resources.Validation.Required)),
    insuranceAmount: number().required(t(Resources.Validation.Required)),
    note: string(),
  }).defined();
};
